import { Component, ErrorInfo, PropsWithChildren } from 'react';
import { ErrorScreen } from './ErrorScreen';

type ErrorBoundaryProps = PropsWithChildren<object>;

interface ErrorBoundaryState {
    hasError: boolean;
    errorMessage: string;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = {
            hasError: false,
            errorMessage: '',
        };
    }

    static getDerivedStateFromError(_error: Error): Partial<ErrorBoundaryState> {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error: Error, _errorInfo: ErrorInfo) {
        this.setState({ hasError: true, errorMessage: error.message });
    }

    render() {
        if (this.state.hasError) {
            return <ErrorScreen errorMessage={this.state.errorMessage} />;
        }
        return this.props.children;
    }
}

export { ErrorBoundary };
